
    .responsive3839243538__root .BadgeIndicator3494530999__root {
        --BadgeIndicator3494530999-color-standard: #116dff;
        --BadgeIndicator3494530999-color-alert: #ee4437;
        --BadgeIndicator3494530999-color-warning: #faad4d;
        --BadgeIndicator3494530999-color-success: #25a55a;
    }

/* st-namespace-reference="../../../../src/skins/responsive/BadgeIndicator.st.css" */